import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";
import { InspectorControls } from "@wordpress/block-editor";
import apiFetch from "@wordpress/api-fetch";
import {
	Panel,
	PanelBody,
	PanelRow,
	SelectControl,
	CheckboxControl, 
	ColorPalette, 
} from "@wordpress/components";
import { useBlockProps } from "@wordpress/block-editor";

export default function Edit({ attributes, setAttributes }) {
	const blockProps = useBlockProps();

	const [tournaments, setTournaments] = useState([]);
	const [selectedTournament, setSelectedTournament] = useState(attributes.tournamentId);

	useEffect(() => {
		fetchTournaments();
	}, []);

	const fetchTournaments = async () => {
		const response = await apiFetch({
			path: "/doubles-rotation-tournament/v1/tournaments",
		});
		console.log("Tournaments:", response); 
		setTournaments(response);
	};

	const handleTournamentChange = (value) => {
		const selectedId = parseInt(value, 10);
		const selectedTournament = tournaments.find((tournament) => tournament.id === selectedId);

		if (selectedTournament) {
			setSelectedTournament(selectedId);
			setAttributes({
				tournamentId: selectedId,
				tournamentName: selectedTournament.name,
			});
		} else {
			console.error("The tournament was not found.", selectedId);
		}
	};

	const getLoginLink = (tournamentId) => {
		const siteUrl = window.location.origin;
		return `${siteUrl}/wp-admin/admin-ajax.php?action=doroto_register_player&tournament_id=${tournamentId}`;
	};

	const selectedTournamentData = tournaments.find(
		(tournament) => tournament.id === parseInt(selectedTournament, 10),
	);

	return (
		<div>
			<InspectorControls>
				<Panel>
					<PanelBody title={__("Settings", "wpdev")} initialOpen={true}>
						<PanelRow>
							<CheckboxControl
								label={__("Hide invitation", "doubles-rotation-tournament")}
								checked={attributes.hideInvitation}
								onChange={(value) => setAttributes({ hideInvitation: value })}
							/>
						</PanelRow>

						<PanelRow>
							<CheckboxControl
								label={__("Hide tournament name", "doubles-rotation-tournament")}
								checked={attributes.hideTournamentName}
								onChange={(value) => setAttributes({ hideTournamentName: value })}
							/>
						</PanelRow>

						<PanelRow>
							<CheckboxControl
								label={__("Hide players count", "doubles-rotation-tournament")}
								checked={attributes.hidePlayerCount}
								onChange={(value) => setAttributes({ hidePlayerCount: value })}
							/>
						</PanelRow>

						<PanelRow>
							<SelectControl
								label={__("Select tournament:", "doubles-rotation-tournament")}
								value={selectedTournament || ""}
								options={[{ label: __("Select tournament", "doubles-rotation-tournament"), value: "" }, ...tournaments.map((tournament) => ({
									label: tournament.name,
									value: tournament.id,
								}))]}
								onChange={(value) => handleTournamentChange(value)}
							/>
						</PanelRow>

						<PanelRow>
							<label>{__("Background color", "doubles-rotation-tournament")}</label>
							<ColorPalette
								value={attributes.backgroundColor}
								onChange={(color) => setAttributes({ backgroundColor: color })}
							/>
						</PanelRow>

						<PanelRow>
							<label>{__("Text color", "doubles-rotation-tournament")}</label>
							<ColorPalette
								value={attributes.textColor}
								onChange={(color) => setAttributes({ textColor: color })}
							/>
						</PanelRow>
					</PanelBody>
				</Panel>
			</InspectorControls>

			{selectedTournamentData ? (
				<table
					{...blockProps}
					style={{
						width: "100%",
						borderCollapse: "collapse",
						marginTop: "20px",
					}}
				>
					<tbody>
						{!attributes.hideInvitation && (
							<tr>
								<td colSpan="2">
									<div
										dangerouslySetInnerHTML={{
											__html: selectedTournamentData.invitation,
										}}
										style={{
											backgroundColor: attributes.backgroundColor || "transparent",
											color: attributes.textColor || "inherit",
										}}
									></div>
								</td>
							</tr>
						)}

						{!attributes.hideTournamentName && (
							<tr>
								<td style={{ padding: "8px" }}>
									<strong>{__("Tournament name:", "doubles-rotation-tournament")}</strong>
								</td>
								<td style={{ padding: "8px" }}>
									{selectedTournamentData.name}
								</td>
							</tr>
						)}

						{!attributes.hidePlayerCount && (
							<tr>
								<td style={{ padding: "8px" }}>
									<strong>{__("Players count:", "doubles-rotation-tournament")}</strong>
								</td>
								<td style={{ padding: "8px" }}>
									{selectedTournamentData.players.length}
									{selectedTournamentData.max_players !== 0 &&
										` / ${selectedTournamentData.max_players}`}
								</td>
							</tr>
						)}

						<tr>
							<td style={{ padding: "8px" }}>
								<strong>{__("Log in link:", "doubles-rotation-tournament")}</strong>
							</td>
							<td style={{ padding: "8px" }}>
								<a
									href={getLoginLink(selectedTournamentData.id)}
									data-type="URL"
									data-id={getLoginLink(selectedTournamentData.id)}
									style={{
										color: attributes.textColor || "inherit",
									}}
								>
									{__("Log in/Log out from the tournament", "doubles-rotation-tournament")}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			) : (
				<p {...blockProps}>
					{__("Select a tournament for details.", "doubles-rotation-tournament")}
				</p>
			)}
		</div>
	);
}
